// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"3830":"2ecb6f2f33560711","8445":"f6efc8d1e0028bf6","8848":"65106ef0c2c6c697"}[chunkId] + ".js";
};